const AIRA_URL = 'https://aira.blue';
const PTBR = 'pt-br';
const USER_SESSION_KEY = 'userSession';
const ROW_HEIGHT_SIZE = 12;
const TABLE_CELL_LIMIT_LENGTH = 25;
const MAX_ROWS_PER_PAGE = 15;
const PHONE_LENGTH = 11;
const TRIAL_NUMBER_LENGTH = 20;
const MIN_PASSWORD_LENGTH = 8;
const CPF_LENGTH = 11;
const CNPJ_LENGTH = 14;
const TRIALS_CSV_FILE_NAME = 'processos';
const PAYMENT_TRIALS_CSV_FILE_NAME = 'pagamento';
const PAYMENT_REICEIPT_DOCUMENT_NAME = 'recibo';
const PAYMENT_REPORT_DOCUMENT_NAME = 'relatorio';
const CASH_FLOWS_CSV_FILE_NAME = 'fluxo-de-caixa';
const SELECT_EMPTY_VALUE = '';

export {
  USER_SESSION_KEY,
  AIRA_URL,
  PTBR,
  ROW_HEIGHT_SIZE,
  TABLE_CELL_LIMIT_LENGTH,
  MAX_ROWS_PER_PAGE,
  PHONE_LENGTH,
  MIN_PASSWORD_LENGTH,
  CPF_LENGTH,
  CNPJ_LENGTH,
  TRIALS_CSV_FILE_NAME,
  CASH_FLOWS_CSV_FILE_NAME,
  SELECT_EMPTY_VALUE,
  TRIAL_NUMBER_LENGTH,
  PAYMENT_TRIALS_CSV_FILE_NAME,
  PAYMENT_REICEIPT_DOCUMENT_NAME,
  PAYMENT_REPORT_DOCUMENT_NAME,
};
